module.exports = __webpack_public_path__ + "static/desktop/img/typeset-calendar.6edefc56.png";